import { Component, Input, OnInit } from '@angular/core';
import { Article } from '../article';

@Component({
  selector: 'app-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss']
})
export class ItemComponent implements OnInit {

  constructor() {
  }

  @Input()
  article: Article | undefined;

  @Input()
  count: number | undefined;

  ngOnInit(): void {
  }

}
